import React, { useState } from "react";
import SEO from "../components/SEO";
import HeroInner from "../components/HeroInner/HeroInner";
import Services from "../components/Services";
import ChatBot from "../components/ChatBot";
import GlobalScripts from "../components/GlobalScripts";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer";
import RelatedAIArticles from "../components/RelatedAIArticles";
import Tooltip from "../components/Tooltip";
import ContactModal from "../components/ContactModal/ContactModal"; // Modal integrado
import "./DesarrolloWeb.css";

function IA() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <SEO
        title="Inteligencia Artificial | Automatización y Chatbots"
        description="Implementación de IA para automatizar procesos, atención al cliente y generación de leads. Mejora tu negocio con tecnología avanzada."
        url="https://juancarlosmancharamos.ar/inteligencia-artificial"
      />

      <Menu />

      <HeroInner
        title="Inteligencia Artificial"
        subtitle="Automatización, chatbots y eficiencia operativa para tu negocio"
        bg="/assets/images/bg-dev.jpg"
      />

      <section className="container dev-section">
        <div className="dev-inner-wrap">
          
          {/* Encabezado y Texto Principal */}
          <div className="dev-header">
            <div className="dev-intro-content">
              <h2 className="dev-title">Automatización Inteligente para Escalar tu Negocio</h2>
              <p className="dev-lead">
                Desarrollo soluciones de Inteligencia Artificial a medida para automatizar procesos operativos, potenciar la atención al cliente y multiplicar la generación de leads calificados.
              </p>
              <p>
                La IA no es el futuro, es tu ventaja competitiva de hoy. A través de la implementación de chatbots inteligentes, integraciones avanzadas con APIs y flujos de trabajo automatizados, transformo tareas manuales y repetitivas en sistemas ultra-eficientes que trabajan por ti 24/7.
              </p>
            </div>
          </div>

          {/* Cuadrícula de Características con Iconos (Enfocados en IA) */}
          <div className="dev-features">
            <div className="dev-feature-card">
              <div className="dev-icon">
                {/* Icono de Bot / Asistente */}
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="10" rx="2" ry="2"></rect><circle cx="12" cy="5" r="2"></circle><path d="M12 7v4"></path><line x1="8" y1="16" x2="8" y2="16"></line><line x1="16" y1="16" x2="16" y2="16"></line></svg>
              </div>
              <h3>Chatbots y Atención 24/7</h3>
              <p>Respuestas instantáneas y precisas para tus clientes en cualquier momento. Mejora la experiencia del usuario y libera a tu equipo de consultas repetitivas.</p>
            </div>

            <div className="dev-feature-card">
              <div className="dev-icon">
                {/* Icono de Engranajes / Automatización */}
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
              </div>
              <h3>Automatización de Procesos</h3>
              <p>Conexión de herramientas y flujos de trabajo mediante IA para eliminar tareas manuales, ahorrando cientos de horas y reduciendo márgenes de error.</p>
            </div>

            <div className="dev-feature-card">
              <div className="dev-icon">
                {/* Icono de Microchip / Procesamiento */}
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line></svg>
              </div>
              <h3>Calificación de Leads</h3>
              <p>Sistemas inteligentes que analizan e interactúan con prospectos en tiempo real, filtrando y derivando las mejores oportunidades de venta a tu equipo.</p>
            </div>

            <div className="dev-feature-card">
              <div className="dev-icon">
                {/* Icono de Gráfico de Rendimiento */}
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline><polyline points="16 7 22 7 22 13"></polyline></svg>
              </div>
              <h3>Reducción de Costos</h3>
              <p>Optimiza los recursos operativos de tu empresa. La inteligencia artificial te permite escalar tu volumen de negocio sin multiplicar tus gastos.</p>
            </div>
          </div>

          {/* Banner de Llamada a la Acción (CTA) */}
          <div className="dev-cta-banner">
            <h3>¿Listo para revolucionar la forma en que trabajas?</h3>
            <p>Implementemos Inteligencia Artificial y lleva la eficiencia de tu negocio al próximo nivel.</p>
            <button 
              onClick={() => setIsModalOpen(true)} 
              className="dev-btn-primary" 
              style={{border: 'none', cursor: 'pointer', fontFamily: 'inherit'}}
            >
              Cotizar Solución de IA
            </button>
          </div>
          
        </div>
      </section>

      {/* Sección + servicios */}
      <section id="abt-lnk" className="center-first">
        <div className="gp no-tpgp btm-spc130">
          <div className="container">
            <div className="skls-wrp2 ovrlp-60 text-center">
              <div className="skls-inr">
                <h2 itemProp="headline">
                  + servicios
                </h2>
              </div>
              <Services />
            </div>
          </div>
        </div>
      </section>

      {/* Artículos Relacionados (Se mantiene tu componente original) */}
      <RelatedAIArticles />
      
      <Footer />
      <ChatBot />
      <Tooltip />
      <GlobalScripts />

      {/* Modal Anti-Spam */}
      <ContactModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        defaultService="Inteligencia Artificial" 
      />
    </>
  );
}

export default IA;